import { string, object, mixed } from 'yup';
import type { TUniversity } from '../types';
import type { TUniversityPayload } from '../services/universities-api';

export const createUniversityInitialValues = ({
  university,
  tab = 'single',
}: {
  university?: TUniversity;
  tab?: 'single' | 'import';
}): TUniversityPayload => {
  if (tab === 'import') {
    return {
      file: null,
    } as TUniversityPayload;
  }

  return {
    name: '',
    description: '',
    main_contact_name: '',
    main_contact_email: '',
    main_contact_phone: '',
    website: '',
    address_line_1: '',
    address_line_2: '',
    city: '',
    state: '',
    postal_code: '',
    country: '',
    logo: undefined,
    status: undefined,
    manager_member: undefined,
    ...createInitialValueFromExistingUniversity({ university }),
  };
};

const createInitialValueFromExistingUniversity = ({
  university,
}: {
  university?: TUniversity;
}): TUniversityPayload => {
  if (!university) return {};

  return {
    name: university.name,
    description: university.description,
    main_contact_name: university.main_contact_name,
    main_contact_email: university.main_contact_email,
    main_contact_phone: university.main_contact_phone,
    website: university.website,
    address_line_1: university.address_line_1,
    address_line_2: university.address_line_2,
    city: university.city,
    state: university.state,
    postal_code: university.postal_code,
    country: university.country.name,
    logo: university.logo,
    status: university.status?.id,
    manager_member: university.manager_member,
  };
};

export const universityFormSchema = object({
  name: string().required('Name is required'),
  website: string()
    .transform((v) => (v === '' || v == null ? undefined : v))
    .nullable()
    .optional()
    .test(
      'url',
      'Please enter a valid website URL (e.g. https://example.com)',
      (value) => {
        if (!value) return true;
        if (!/^https?:\/\//i.test(value)) return false;
        try {
          new URL(value);
          return true;
        } catch {
          return false;
        }
      }
    ),
});

export const importUniversitiesFormSchema = object({
  file: mixed()
    .required('Import File is required')
    .test('file-required', 'File is required', (value) => {
      return value !== null && value !== undefined;
    }),
});
